import { Controller } from "@hotwired/stimulus";

import { swapChildren } from "~/htmx";
import logger from "~/lib/logger";

const log = logger();

/**
 * Load the query of a `chart:open` event URL from the `url` value into the
 * content target with htmx, instead of a page navigation to the event URL.
 */
export default class ChartSwapController extends Controller<HTMLElement> {
  static override targets = ["content"];
  static override values = { url: String };

  declare readonly contentTarget: HTMLElement;
  declare readonly urlValue: string;

  open(event: CustomEvent<{ url: string }>): void {
    event.preventDefault();
    const { search } = new URL(event.detail.url, location.href);
    swapChildren(
      this.contentTarget,
      this.urlValue + search,
      event.detail.url,
    ).catch((reason: unknown) => {
      log.error("Failed to load the chart URL:", reason);
    });
  }
}
